import * as yup from "yup";
import { validation } from "@/constants/validation.translation";
import constants from "@/libs/constant";

/**
 * Validation class for User Master form
 * Contains validation schema for all user master fields
 */
class UserMasterValidationClass {
  
  /**
   * Deactivate User validation schema
   * @param {function} t - Translation function
   * @returns {yup.ObjectSchema} Validation schema for deactivate user
   */
  static deactivateUserValidation(t = (key) => key) {
    return yup.object().shape({
      reason: yup
        .string()
        .required(t("admin.deactivate_user_reason_required"))
        .min(constants.validation.userMaster.deactivateReason.minLength, t("admin.deactivate_user_reason_min_length"))
        .max(constants.validation.userMaster.deactivateReason.maxLength, t("admin.deactivate_user_reason_max_length"))
    });
  }
}

export default UserMasterValidationClass;
